import { toast } from 'react-toastify';

const dev = process.env.NODE_ENV === 'development';

export async function APIRequest(action){
  const { REACT_APP_API_ENDPOINT } = process.env;
  const {
    method,
    url,
    data,
    notification = true,
    env = true
  } = action;

  let reqURL = REACT_APP_API_ENDPOINT + url;
  if (env === false){
    reqURL = url;
  }

  const requestHeaders = new Headers();
  requestHeaders.set('Content-Type', 'application/json');

  if (dev){
    requestHeaders.set('Access-Control-Allow-Origin', '*');
    requestHeaders.set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept');
    requestHeaders.set('Access-Control-Allow-Methods', 'POST, GET, PUT, OPTIONS, PATCH, DELETE');
  }

  return (
    fetch(reqURL, {
      method,
      headers: requestHeaders,
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(res => {
        if (res){
          switch (res.code){
            case 0:
            case 200:
              return res;

            default:
              if (notification) toast.error(res.message || 'เกิดข้อผิดพลาด');
              return res;
          }
        }

        if (notification){
          if (res.code === 1003 || res.code === 1005){
            console.log('1003');
          } else {
            toast.error(res.message || 'เกิดข้อผิดพลาด');
          }
          return res;
        }

        return null;
      })
      .catch(error => {
        console.error('report error : ', error);
        if (notification){
          toast.error(error.message || 'เกิดข้อผิดพลาด');
        }
        return error;
      })
  );
}

export async function APIRequestUpadload(action){
  const { REACT_APP_API_ENDPOINT } = process.env;
  const {
    method,
    url,
    data,
    notification = true,
    env = true
  } = action;

  let reqURL = REACT_APP_API_ENDPOINT + url;
  if (env === false){
    reqURL = url;
  }

  const requestHeaders = new Headers();

  return (
    fetch(reqURL, {
      method,
      headers: requestHeaders,
      body: data
    })
      .then(response => response.json())
      .then(res => {
        if (res){
          switch (res.code){
            case 0:
            case 200:
              return res;

            default:
              if (notification) toast.error(res.message || 'เกิดข้อผิดพลาด');
              return res;
          }
        }

        if (notification){
          if (res.code === 1003 || res.code === 1005){
            console.log('1003');
          } else {
            toast.error(res.message || 'เกิดข้อผิดพลาด');
          }
          return res;
        }

        return null;
      })
      .catch(error => {
        console.error('report error : ', error);
        if (notification){
          toast.error(error.message || 'เกิดข้อผิดพลาด');
        }
        return error;
      })
  );
}
